import { addBeforeUnload } from "../../generativeAi/actions";
import { selectSharepoint } from "../selectors";
import { setEdits } from "../sharepointSlice";

export const setFormEdits = (data) => {
  return (dispatch, getState) => {
    const sharepoint = selectSharepoint(getState());
    const { edits = {} } = sharepoint || {};
    const isDirty = Boolean(Object.keys(edits).length);

    dispatch(setEdits(data));
    if (!isDirty) {
      dispatch(addBeforeUnload());
    }
  };
};
